var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "collection-banner",
    class: {
      'container-fluid': _vm.isGridWidthLayout,
      'pad-with-bg': !_vm.isGridWidthLayout && _vm.hasBackground,
      'layout-with-background': _vm.isGridWidthLayout && _vm.hasBackground
    }
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "pb-3 text-center"
  }, [_c('GlobalTitle', {
    attrs: {
      "title": _vm.currentPayload.title
    }
  })], 1)]), _vm._v(" "), _c(_vm.type, {
    tag: "component",
    class: {
      row: _vm.isGridWidthLayout
    },
    attrs: {
      "href": _vm.currentPayload.button.url,
      "target": _vm.currentPayload.button.target
    },
    on: {
      "click": function click($event) {
        return _vm.$root.$emit('generic-tracking', $event, _vm.currentPayload.tracking);
      }
    }
  }, [_c('div', {
    staticClass: "collection-banner bg-cover-center lazyload banner",
    class: [_vm.hasBackground ? 'layout-with-background' : 'layout-without-background', {
      'col-12': _vm.isGridWidthLayout
    }],
    style: {
      'background-color': _vm.currentPayload.background_color,
      color: _vm.currentPayload.text_color
    },
    attrs: {
      "data-bgset": "\n        ".concat(_vm.currentPayload.background_image.small, " 375w,\n        ").concat(_vm.currentPayload.background_image.medium, " 750w,\n        ").concat(_vm.currentPayload.background_image.large, " 1440w,\n        ").concat(_vm.currentPayload.background_image.xlarge, " 2880w\n        "),
      "data-sizes": "auto"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-11 col-lg-8 text-center"
  }, [_vm.currentPayload.image.url ? _c('img', {
    staticClass: "lazyload img-fluid mb-3",
    attrs: {
      "data-srcset": "".concat(_vm.currentPayload.image.small, " 375w, ").concat(_vm.currentPayload.image.medium, " 750w, ").concat(_vm.currentPayload.image.large, " 1440w"),
      "data-src": _vm.currentPayload.image.small,
      "data-sizes": "auto",
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('GlobalTitle', {
    attrs: {
      "title": _vm.currentPayload.title_banner
    }
  }), _vm._v(" "), _c('GlobalTitle', {
    staticClass: "valentine",
    attrs: {
      "title": _vm.currentPayload.subtitle
    }
  }), _vm._v(" "), _c('SimpleParagraph', {
    staticClass: "mb-3",
    attrs: {
      "paragraph": _vm.currentPayload.paragraph
    }
  }), _vm._v(" "), _vm.currentPayload.button.text ? _c('span', {
    staticClass: "btn",
    class: [_vm.currentPayload.paragraph ? 'mt-1' : 'mt-3', _vm.currentPayload.button.color],
    domProps: {
      "textContent": _vm._s(_vm.currentPayload.button.text)
    }
  }) : _vm._e()], 1)])])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };